export enum MetadataTypeEnum {
  BOOKING = "BOOKING",
  SHIPMENT = "SHIPMENT",
  QUALITY = "QUALITY",
}
